import SourceProductPrice from 'SourceComponent/ProductPrice/ProductPrice.component';

export default class ProductPrice extends SourceProductPrice {
    renderCurrentPrice() {
        const {
            formattedCartRuleSpecialPrice,
            formatedCurrency,
            currency,
            discountPercentage
        } = this.props;

        const schema = this.getCurrentPriceSchema();

        if (formatedCurrency == 0 && (!formattedCartRuleSpecialPrice || formattedCartRuleSpecialPrice === 0)) {
            return null;
        }

        const currentPrice = formattedCartRuleSpecialPrice ? formattedCartRuleSpecialPrice : formatedCurrency;
        const priceStyle = formattedCartRuleSpecialPrice || discountPercentage !== 0 ? "SpecialPrice" : null;


        return (
            <ins className={priceStyle}>
                <data
                    value={currentPrice}
                >
                    <span>{currentPrice}</span>
                    <span>{` ${currency}`}</span>
                </data>
            </ins>
        );
    }

    renderSchema() {
        const {isSchemaRequired, priceCurrency, formattedCartRuleSpecialPrice, formatedCurrency} = this.props;

        const crsp = this.props.cartRuleSpecialPrice?.price;
        const price = this.props.price?.minimum_price?.final_price?.value;
        const priceForPoints = crsp ? crsp : (price || 0);
        const estimatedPoints = priceForPoints ? Math.floor(priceForPoints / 10) : null;

        const currentPrice = formattedCartRuleSpecialPrice ? formattedCartRuleSpecialPrice : formatedCurrency;

        if (isSchemaRequired) {
            return (
                <React.Fragment>
                    <>
                        <meta itemProp="price" content={currentPrice.toString().replace(',', '.')}/>
                        <meta itemProp="priceCurrency" content={priceCurrency}/>
                    </>
                </React.Fragment>
            );
        }

        return null;
    }

    renderOldPrice() {
        const {
            roundedRegularPrice,
            discountPercentage,
            isSchemaRequired,
            variantsCount,
            currency,
            formattedCartRuleSpecialPrice
        } = this.props;

        const schema = isSchemaRequired && variantsCount > 1 ? {itemProp: 'highPrice'} : {};

        if (discountPercentage === 0 && (!formattedCartRuleSpecialPrice || formattedCartRuleSpecialPrice === 0)) {
            return null;
        }
        return (
            <del
                block="ProductPrice"
                elem="HighPrice"
                aria-label={__('Old product price')}
                {...schema}
            >
                <span>{roundedRegularPrice}</span>
                <span>{` ${currency}`}</span>
            </del>
        );
    }
}
